"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashReceiptFields = void 0;
var CashReceiptFields;
(function (CashReceiptFields) {
    CashReceiptFields["TypeCode"] = "typeCode";
    CashReceiptFields["AdmissibleAmount"] = "admissibleAmount";
    CashReceiptFields["AdmissibleDate"] = "admissibleDate";
    CashReceiptFields["Comment"] = "comment";
    CashReceiptFields["IndexNumber"] = "indexNumber";
    CashReceiptFields["PartialPaymentAppliedToInterestAmount"] = "partialPaymentAppliedToInterestAmount";
    CashReceiptFields["PartialPaymentAppliedToPrincipalAmount"] = "partialPaymentAppliedToPrincipalAmount";
    CashReceiptFields["PartialPaymentAppliedToTaxAmount"] = "partialPaymentAppliedToTaxAmount";
    CashReceiptFields["PreviouslyApprovedAmount"] = "previouslyApprovedAmount";
    CashReceiptFields["PreviouslyApprovedDate"] = "previouslyApprovedDate";
    CashReceiptFields["ReceivedAmount"] = "receivedAmount";
    CashReceiptFields["ReceivedDate"] = "receivedDate";
})(CashReceiptFields = exports.CashReceiptFields || (exports.CashReceiptFields = {}));
